import React, { useCallback } from 'react'
import cn from 'classnames'
import debounce from 'lodash/debounce'

export default function SearchInput2({ name = 'search', pageKey = 'page', setSearchParams, searchParams, ...attributes }) {
    const [value, setValue] = React.useState(searchParams?.[name] || '')

    React.useEffect(() => {
        setValue(searchParams?.[name] || '')
    }, [searchParams?.[name]])

    const debouncedSearch = React.useMemo(
        () => debounce((val) => {
            setSearchParams((prev) => ({ ...prev, [name]: val || undefined, [pageKey]: undefined }))
        }, 500),
        [setSearchParams, name, pageKey]
    )

    const onChange = (e) => {
        setValue(e.target.value)
        debouncedSearch(e.target.value)
    }

    return (
        <input
            type="search"
            value={value}
            onChange={onChange}
            className={cn('input')}
            placeholder="Поиск..."
            {...attributes}
        />
    )
}
